import React from "react";
import SideNavbar from "../../components/Sidenavbar";
import AppViews from "../../views/app-views/";
import "react-toastify/dist/ReactToastify.css";
import useDevice from "../../utils/useDevice";
import Mobile from "../../components/Sidenavbar/Mobile";

const AppLayout = () => {
  const { isMobile } = useDevice();
  return (
    <div className="LayoutContainer min-h-screen flex">
      <div className="lg:w-72 xl:w-96 h-full z-50 ">
        {isMobile ? <Mobile /> : <SideNavbar />}
      </div>

      <div className=" w-full animate__animated animate__fadeIn pt-24 bg-[#e6e7eb]">
        <AppViews />
      </div>
    </div>
  );
};

export default AppLayout;
